import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
var LocationGroupApi = /** @class */ (function () {
    function LocationGroupApi(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    LocationGroupApi.prototype.searchOne = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: this.queries.searchLocationGroup(),
                        variables: { id: id }
                    }).toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['locationGroup'];
                    })];
            });
        });
    };
    LocationGroupApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationGroupApi_Factory() { return new LocationGroupApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries)); }, token: LocationGroupApi, providedIn: "root" });
    return LocationGroupApi;
}());
export { LocationGroupApi };
